import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotBusinessComponent } from './not-business.component';
import { NotBusinessRoutingModule } from './not-business-routing.module';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzGridModule } from 'ng-zorro-antd/grid';

@NgModule({
  declarations: [NotBusinessComponent],
  imports: [
    CommonModule,
    NotBusinessRoutingModule,
    NgZorroAntdModule,
    NzGridModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NzSpinModule,
  ],
  providers: []
})
export class NotBusinessModule { }
